// Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import { createTheme } from '@mui/material/styles';

const theme = createTheme()

const useStyles = makeStyles(() => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 10,
        color: '#fff',
    },
    label: {
        fontSize: 18,
        fontWeight: "bold",
        paddingLeft: "10px"
    }
}));

const BackdropProgress = ({ open }) => {
    const classes = useStyles();

    return (
        <Backdrop className={classes.backdrop} open={open}>
            <CircularProgress color='inherit' />
            <span className={classes.label}>Please wait</span>
        </Backdrop>
    )
}

export default BackdropProgress;
